import { TextField } from "@mui/material";

type IProps = {
  name: string;
  label: string;
  formik: any;
  sx?: any;
  handleChange?: any;
  disabled?: boolean;
  children: any;
};

const FormikSelect: React.FC<IProps> = ({
  name,
  label,
  formik,
  sx,
  handleChange,
  disabled = false,
  children,
}) => {
  return (
    <TextField
      sx={sx}
      variant="outlined"
      fullWidth
      name={name}
      select
      label={label}
      value={formik.values[name]}
      disabled={disabled}
      onChange={(e: any) => {
        if (handleChange) {
          handleChange(e.target.value);
        }
        formik.setFieldValue(name, e.target.value);
      }}
      error={formik.touched[name] && Boolean(formik.errors[name])}
      helperText={formik.touched[name] && formik.errors[name]}
    >
      {children}
    </TextField>
  );
};

export default FormikSelect;
